import type { IconType } from 'react-icons';

import s from './SectionHeader.module.scss';

interface SectionHeaderProps {
  icon?: IconType;
  title: string;
  className?: string;
}

export function SectionHeader({ icon, title, className }: SectionHeaderProps) {
  const Icon = icon;

  return (
    <div className={`${s.header} ${className || ''}`}>
      <div className={s.icon}>{Icon ? <Icon aria-hidden="true" /> : null}</div>
      <div className={s.title}>{title.toUpperCase()}</div>
    </div>
  );
}
